<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
    [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle" [status]="status" [msg]="statusMsg" [token]="token">
    <div class="card-msg d-flex flex-column bg-white text-dark text-center">
        {{texto}}
    </div>
</app-card-consulta>


<div *ngIf="consulta.parecerTecnico" class="mt-2 mt-lg-3">
    <app-card-consulta titulo="Parecer Técnico" [idConsulta]='idConsulta' [tipoConsulta]="tipoConsulta"
        [codigoControle]="codigoControle"
        [status]="consulta.parecerTecnico==1 ? 'success' : consulta.parecerTecnico==2 ? 'warning' : 'danger' "
        [msg]="consulta.parecerTecnico==1 ? 'NADA CONSTA' : consulta.parecerTecnico==2 ? 'RISCO MÉDIO' : 'RISCO ALTO'">
    </app-card-consulta>
</div>
